/** Partilhar com pessoas: os pedidos à API (/api/partilhas). */
import { api } from '@core/api/client'
import type { ItemComigo, PartilhaInfo, PessoaEncontrada } from './partilhasRegras'

const BASE = '/api/partilhas'

export const partilhasApi = {
  ver: (id: string) => api.get<PartilhaInfo>(`${BASE}/${encodeURIComponent(id)}`),
  comigo: () => api.get<ItemComigo[]>(`${BASE}/comigo`),
  pesquisar: (q: string) =>
    api.get<PessoaEncontrada[]>(`${BASE}/pessoas?q=${encodeURIComponent(q)}`),
  /** Dá acesso a pessoas (por email) e/ou ao workspace inteiro. */
  acrescentar: (id: string, emails: string[], workspace = false, enviarEmail = true) =>
    api.post<PartilhaInfo>(`${BASE}/${encodeURIComponent(id)}/acessos`, {
      emails,
      workspace,
      enviar_email: enviarEmail,
    }),
  remover: (id: string, acessoId: string) =>
    api.delete<PartilhaInfo>(
      `${BASE}/${encodeURIComponent(id)}/acessos/${encodeURIComponent(acessoId)}`,
    ),
  /** Retirar a partilha: saem todos os acessos; o recurso fica só para o dono. */
  retirar: (id: string) => api.delete<PartilhaInfo>(`${BASE}/${encodeURIComponent(id)}/acessos`),
}
